export const DEVELOPMENT_STAGES = [
  { value: 'PRE_LAUNCH', label: 'Pre-launch' },
  { value: 'UNDER_CONSTRUCTION', label: 'Under Construction' },
  { value: 'READY_TO_MOVE', label: 'Ready to Move' },
];

export const getDevelopmentStageLabel = (stage) =>
  DEVELOPMENT_STAGES.find((item) => item.value === stage)?.label || 'Ready to Move';
